<template>
  <div id="app">
    <keep-alive>
		  <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>
<script>
import enquireScreen from '@/utils/device'

export default {
  name: 'app',
  data() {
    return {}
  },
  created() {
    let that = this
    enquireScreen(deviceType => {
      if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
      }
    })
  },
  beforeCreate() {}
}
</script>
<style>
#app {
  height: 100%;
}
input {
  border: none;
  font-size: 14px;
}
input::-webkit-input-placeholder {
  color: #969799;
}
textarea::-webkit-input-placeholder {
  color: #969799;
}
* {
  margin: 0px;
  padding: 0px;
}
.van-toast {
  width: 80% !important;
}
@font-face {
  font-family: 'fzqk';
  src: url('./assets/font/fzqk.TTF');
}
body {
  /*overflow: hidden;*/
}
.jzz{
  width: 100%;
  display: flex;
  padding: 60px 0px 0px;
  justify-content: center;
}
</style>
